import { render, staticRenderFns } from "./statusNotification.vue?vue&type=template&id=6f88d7c7&scoped=true"
import script from "./statusNotification.vue?vue&type=script&lang=js"
export * from "./statusNotification.vue?vue&type=script&lang=js"
import style0 from "./statusNotification.vue?vue&type=style&index=0&id=6f88d7c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f88d7c7",
  null
  
)

export default component.exports